import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { ReserveComputationTableContext, IReserveComputationTableContext } from './ReserveComputationTableContext';
import { IReserveComputationDate } from './';
import { useDrawer } from '@features/Modal';
import { ReserveComputationDrawer } from '../../components';

export const ReserveComputationTableProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [dateRange, setDateRange] = useState<[string | null, string | null]>([
        moment().subtract(1, 'days').format(),
        moment().subtract(10, 'days').format(),
    ]);
    const [dates, setDates] = useState<IReserveComputationDate[]>([]);

    useEffect(() => {
        const start = moment(dateRange[0]);
        const end = moment(dateRange[1]);
        const dates = [];

        while (start.isSameOrBefore(end)) {
            dates.push({ date: start.format('DD MMMM, YYYY') });
            start.add(1, 'days');
        }

        setDates(dates.reverse());
    }, [dateRange]);

    const { open: openReserveComputationDrawer } = useDrawer(ReserveComputationDrawer);

    const onReserveComputationClick = (date: IReserveComputationDate) => {
        openReserveComputationDrawer({ date });
    };

    const value: IReserveComputationTableContext = {
        dateRange,
        dates,
        setDateRange,
        onReserveComputationClick,
    };

    return <ReserveComputationTableContext.Provider value={value}>{children}</ReserveComputationTableContext.Provider>;
};
